export default __webpack_public_path__ + "static/media/logo_white_icon.8202bfe7.svg";